/* tslint:disable */
import {
  UserProfile
} from '../index';

declare var Object: any;
export interface VendorCategoriesInterface {
  "group_name": string;
  "name": string;
  "id"?: number;
  "vendor_id"?: number;
  "vendor_category_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  userProfile?: UserProfile;
}

export class VendorCategories implements VendorCategoriesInterface {
  "group_name": string;
  "name": string;
  "id": number;
  "vendor_id": number;
  "vendor_category_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  userProfile: UserProfile;
  constructor(data?: VendorCategoriesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VendorCategories`.
   */
  public static getModelName() {
    return "VendorCategories";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VendorCategories for dynamic purposes.
  **/
  public static factory(data: VendorCategoriesInterface): VendorCategories{
    return new VendorCategories(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VendorCategories',
      plural: 'VendorCategories',
      path: 'VendorCategories',
      idName: 'id',
      properties: {
        "group_name": {
          name: 'group_name',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "vendor_id": {
          name: 'vendor_id',
          type: 'number'
        },
        "vendor_category_id": {
          name: 'vendor_category_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        userProfile: {
          name: 'userProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'vendor_id',
          keyTo: 'id'
        },
      }
    }
  }
}
